var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 48,
    viewBox: "0 0 103 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2101_3511)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.244 18.7236L96.1409 14.621H88.519V9.3443H82.0694V33.3796H88.519V21.0682H93.7942V33.3796H100.244V18.7236ZM79.726 14.621H69.7601L65.6563 18.7236V29.2752L69.7601 33.3796H79.726V26.9318H72.1041V21.0682H79.726V14.621ZM63.3114 14.621H58.0362V9.3443H51.5866V29.2752L55.6904 33.3796H63.3114V26.9318H58.0362V21.0682H63.3114V14.621ZM49.2417 9.3443H42.7939V12.2764H49.2417V9.3443ZM49.2417 14.621H42.7939V33.3793H49.2417V14.621ZM40.449 14.621H34.0006V26.9318H31.6563V14.621H25.2076V26.9318H22.8636V14.621H16.414V33.3796H36.3461L40.449 29.2752V14.621ZM14.0691 14.621H8.7936V9.3443H2.3452V29.2752L6.4487 33.3796H14.0691V26.9318H8.7936V21.0682H14.0691V14.621ZM102.587 17.551V35.1373L93.7942 41H87.9324V38.0679L83.8289 41H78.5537V38.0679L75.6234 41H66.2435L63.3114 38.0679L62.7245 41H54.5187L51.163 38.0679L50.975 41H41.6739L41.345 38.0679L38.8272 41H24.6207L21.6892 39.8274V41H14.0691L5.2755 35.7227L0 30.4493V7H11.1388L16.414 12.2764H40.449V7H60.3802V12.2764H65.6563V15.2067L68.5884 12.2764H74.4493L79.726 7H90.8639V12.2764H97.3126L102.587 17.551Z",
    fill: "#46453D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2101_3511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.69b4a4ae88d1b0d06856a479375d57f1.svg";
export { ForwardRef as ReactComponent };